<div
  class="d-flex flex-column justify-content-center align-items-center h-100 text-center"
>
  <svg
    id="f9eb83fe-2109-496c-8de2-d29751931755"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 1166.17 805.09"
    class="mt-5"
  >
    <defs>
      <linearGradient
        id="b7f84a8b-804f-4004-8d61-2f9b427d4893"
        x1="785.51"
        y1="659.88"
        x2="938.51"
        y2="659.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="gray" stop-opacity="0.25" />
        <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
        <stop offset="1" stop-color="gray" stop-opacity="0.1" />
      </linearGradient>
    </defs>
    <title>authentication</title>
    <path
      d="M676.53,157.07c-74.75.1-146.7-21.09-215.52-44.63S323.9,62.54,250.54,51.37c-47.18-7.18-100.83-6.52-137.71,19.55C77.33,96,67.05,137.51,62.09,175.86c-3.73,28.85-5.45,59.13,8.52,85.52,9.7,18.32,26.3,33.42,38,50.88C149.45,373,124.89,450.59,85.2,512.74c-18.61,29.16-40.41,57.11-54.48,87.94s-19.84,65.79-5.49,96.22c14.22,30.16,46.34,52.05,80.81,67,70,30.42,151.5,36.94,230.81,39.45,175.56,5.57,351.46-5.79,526.89-17.15,64.92-4.2,130.13-8.43,193.71-20.6,35.3-6.75,71.65-16.77,96.68-38.73,31.77-27.88,38.27-73.4,15.15-106.12-38.77-54.88-141-65.23-168.8-124.61-15.33-32.69-2.11-70.18,17.36-101.69,41.76-67.61,113.64-128.17,114.85-203.79.83-51.93-36.55-102.59-92.38-125.16C981.79,41.86,902,47.94,861,92,818.84,137.39,742.53,157,676.53,157.07Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
      opacity="0.1"
    />
    <path
      d="M1009.44,692.82s-12.29-8.11-24.47-2.34c0,0,3.75,7.22,19.17,6.54Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1011,693.25s3.74,14.24-5.64,23.93c0,0-5.64-5.87,0-20.25Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1026.28,679.58s-.91-12.11-28.26-8.09c0,0-.13,7.81,9.47,11.51S1021.49,683.58,1026.28,679.58Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1028,679.5s11.56,3.71,1.25,29.36c0,0-7.63-1.7-9-11.91S1022.94,683.22,1028,679.5Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1043.44,662.32s1.57-19.93-26.38-17.89c0,0-2,18,21.45,22.68Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1061.91,639.82s-3.83-22.59-31.77-15.86c0,0-.1,19.53,27.21,21.24Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1075.41,616.56s-6.42-22-34.1-15.42c0,0,6.59,19.79,32.26,19.48Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1088.23,593.84s-6.27-22.83-33-16c0,0,8.92,21.69,31.23,19.86Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1096.49,572.26s-4.82-27.92-29.74-21.74c0,0,7.24,25.4,27.91,25.81Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1104.24,546.19s-5.79-28.14-31-20c0,0,9.88,26.6,29.21,23.85Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1109,521.93s-9.19-28.15-28.68-27.39c0,0,9.39,29.73,27.05,33Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1112.08,498.25s-10-33.88-25.86-31.27c0,0,6.92,25.9,25.3,36.55Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1113.82,470s-9.38-28.23-25-29.36c0,0,6.38,27.78,24.69,36.7Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1115.71,443.64s-11.69-28.26-22-28.9c0,0,5.08,27.83,21,33.54Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1117,419.12s-7.19-30.69-17.52-33.24c0,0,1.41,25.11,16.48,35.54Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1120.9,387s-7.56-24.47-15.93-28.2c0,0,1.65,28.85,14,34.18Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1124.13,366l1.52-43.14S1110,355.38,1123,373.57Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1136.21,323.09s11.27-31.5,14-33.26c0,0-22.1,20.44-19.94,46.73Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1044.2,662.17s19.82-2.59,19.23,25.42c0,0-17.91,2.92-23.76-20.25Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1062.85,639.06s22.9-.07,21,28.6c0,0-19.23,3.44-25.57-23.18Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1075.63,618.41s20.79-9.75,34.09,15.42c0,0-19.2,8.12-35.93-11.35Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1088.69,594.05s21.29-10.37,33.79,14.21c0,0-22.18,7.64-35.55-10.32Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1096.22,572.87s20.49-19.57,36.84.22c0,0-20.93,16.11-37.78,4.14Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1103.08,545.52s20.61-20,36.83.92c0,0-23.13,16.43-37.57,3.28Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1106.93,521.13s15.88-25,34.58-19.42c0,0-16.48,26.47-34.4,25.29Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1111.61,498.09s16-31.48,31.14-26c0,0-11.54,24.2-31.55,31.31Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1112.72,468.36s16.45-24.78,31.86-21.75c0,0-13.45,25.13-33.46,28.92Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1114,443.09s12.75-27.81,23.11-28c0,0-6.12,27.61-22.25,32.72Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1116.5,418.52s14.17-28.16,24.82-28.22c0,0-7.25,24.08-24.35,30.69Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1118.63,388.76s10.6-23.3,19.38-25.94c0,0-5.3,28.4-18.21,32.12Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1125.39,365.15l23.69-36.09s-6.07,35.6-27.15,43Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1141.65,326s27.53-19,28.53-22.07c0,0-14,26.61-40,31.31Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1143.3,317.45s31.61-30.39,39.68-30.36c0,0-26.07,1.19-40.44,28.74Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M1118.94,393.27l1.15.15c5.94-46.49,14.6-74,24.38-77.37l-.38-1.1C1133.72,318.55,1125,345.64,1118.94,393.27Z"
      transform="translate(-16.91 -47.46)"
      fill="#444053"
    />
    <path
      d="M1110.2,504.45l1.74.14c.37-4.34.65-8.78.84-13.21,1.66-38.48,4.23-73.82,7.61-100.31l-1-1.25c-3.39,26.55-6.69,62.95-8.35,101.49C1110.85,495.71,1110.57,500.13,1110.2,504.45Z"
      transform="translate(-16.91 -47.46)"
      fill="#444053"
    />
    <path
      d="M977,715c.3-.13,30.93-13.81,62.72-46.43a252.22,252.22,0,0,0,45.85-65c14.7-29.93,23.66-66.71,26.66-102.44l-1.81.85c-6.75,80.2-43.26,135-72.29,164.85-31.48,32.33-61.77,45.87-62.07,46Z"
      transform="translate(-16.91 -47.46)"
      fill="#444053"
    />
    <path
      d="M1056.31,132.69H95.43a8.56,8.56,0,0,0-8.56,8.56v24.94h978V141.25A8.56,8.56,0,0,0,1056.31,132.69Z"
      transform="translate(-16.91 -47.46)"
      fill="#3f3d56"
    />
    <path
      d="M86.87,166.19V727.43a17.26,17.26,0,0,0,17.26,17.26h943.48a17.26,17.26,0,0,0,17.26-17.26V166.19Z"
      transform="translate(-16.91 -47.46)"
      fill="#fff"
    />
    <circle cx="85.45" cy="101.73" r="4" fill="#fa5959" opacity="0.8" />
    <circle cx="96.45" cy="101.73" r="4" fill="#fed253" opacity="0.8" />
    <circle cx="107.45" cy="101.73" r="4" fill="#8ccf4d" opacity="0.8" />
    <rect x="160.87" y="212.31" width="786" height="345.62" opacity="0.05" />
    <rect x="166.87" y="214.93" width="774" height="338" fill="#3f3d56" />
    <path
      d="M394.78,349.38a77,77,0,1,0,77,77A77,77,0,0,0,394.78,349.38Zm13.81,78.85v36.46H381.37V428.23a22.55,22.55,0,1,1,27.22,0Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M394.78,349.38a77,77,0,1,0,77,77A77,77,0,0,0,394.78,349.38Zm13.81,78.85v36.46H381.37V428.23a22.55,22.55,0,1,1,27.22,0Z"
      transform="translate(-16.91 -47.46)"
      opacity="0.05"
    />
    <path
      d="M394.78,327.38a99,99,0,1,0,99,99A99,99,0,0,0,394.78,327.38Zm17.75,101.38v46.87h-35V428.76a29,29,0,1,1,35,0Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <rect x="517.87" y="365.93" width="320" height="34" fill="#fff" />
    <rect x="768.87" y="427.93" width="69" height="34" fill="#158cba" />
    <path
      d="M566.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L553.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L552.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,566.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M587.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L574.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L573.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,587.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M608.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L595.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L594.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,608.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M629.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L616.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L615.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,629.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M650.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L637.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L636.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,650.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M671.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L658.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L657.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,671.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M692.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L679.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L678.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,692.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M713.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L700.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L699.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,713.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M734.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L721.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L720.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,734.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M755.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L742.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L741.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,755.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M776.28,429.88h-5.79l5.15-5.14a.51.51,0,0,0,0-.71.5.5,0,0,0-.71,0l-5.15,5.15v-5.8a.5.5,0,0,0-.5-.5.51.51,0,0,0-.5.5v5.8L763.64,424a.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71l5.15,5.14h-5.8a.51.51,0,0,0-.5.5.5.5,0,0,0,.5.5h5.8L762.93,436a.51.51,0,0,0,0,.71.52.52,0,0,0,.71,0l5.14-5.15v5.79a.5.5,0,0,0,.5.5.5.5,0,0,0,.5-.5v-5.79l5.15,5.15a.52.52,0,0,0,.71,0,.51.51,0,0,0,0-.71l-5.15-5.15h5.79a.5.5,0,0,0,.5-.5A.5.5,0,0,0,776.28,429.88Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M937.27,551.53a17.9,17.9,0,0,0-.45-3.59c-.9-3.38-2.93-7.47-6.27-8.49a52.64,52.64,0,0,1-9.94-4.2c-.6-10.72,1.86-21.69-.82-32.08-1-3.8-2.65-7.44-3.09-11.33-.55-4.84.77-10-1.16-14.46-1.52-3.52-4.86-6-8.45-7.3s-7.46-1.65-11.27-2c-4.8-.39-20.34-2.23-25.76,2.06h0a5.66,5.66,0,0,0-1,1l0,0a4,4,0,0,0-.32.52l-.05.08a4.06,4.06,0,0,0-.27.65h0a5.06,5.06,0,0,0-.17.75c0,.08,0,.16,0,.24s0,.35,0,.53v.27c0,.18,0,.36,0,.55s0,.14,0,.21c.07.9.2,1.8.2,2.69a5.79,5.79,0,0,1-.12,1.32,9.24,9.24,0,0,1-1.66,3.24h0l-.18.26c-.11.16-.22.31-.32.47s-.18.28-.26.42-.16.23-.23.36a4.89,4.89,0,0,0-.26.51c0,.1-.11.19-.15.29a4.94,4.94,0,0,0-.3.84,5.58,5.58,0,0,0-.06,2.66,9.9,9.9,0,0,0,1.37,3.15c.25.41.52.81.8,1.21l.7.95a21.58,21.58,0,0,0-.21,2.8,20.69,20.69,0,0,0,7.9,16.26,61.25,61.25,0,0,1-.13,12.69c-.09.88-.2,1.77-.32,2.65s-.21,1.46-.33,2.19a10.15,10.15,0,0,1-4.37-.33,20.59,20.59,0,0,0-2-.77c-2.91-.73-5.88,2.17-8.76,1.29,0,.14-.08.27-.13.4a3.92,3.92,0,0,0-2-.59c-1.71-.08-3.1-1.32-4.34-2.49l-3.81-3.59a4.21,4.21,0,0,1-.66-.74,5.19,5.19,0,0,1-.46-1.23c-.64-2.07-2.19-3.72-3.69-5.29a2.5,2.5,0,0,0-1.09-.79,1.68,1.68,0,0,0-.5,0,4.39,4.39,0,0,0-.33-.4,9.41,9.41,0,0,0-.83-.84c-1.82-1.68-2-3.12-3.58-5a48.05,48.05,0,0,1-3.74-5.65c-.13-1.05-.31-2.13-.53-3.22a41.43,41.43,0,0,0-2.19-7.3l-2-4.43-.23.23c-1.45-2.16-3-3.34-4.39-3.06-2.33.48-3.48,5-3.11,10.91l.8,6c0,.15.07.3.11.45a11.07,11.07,0,0,0-.22,2.16c0,.84.78,1.46,1.19,2.21a6.25,6.25,0,0,1,1,3.41c-.05.43-.18.84-.2,1.26a4.85,4.85,0,0,0,.94,2.6l5,8.4,1,1.76.06.08a4.27,4.27,0,0,0,1.34,1.54,18.32,18.32,0,0,0,1.65,6.07c.17.38.36.74.56,1.1a35.37,35.37,0,0,0,4.72,6.13l2.38,2.67c2.35,2.62,4.7,5.25,7.25,7.67a9.71,9.71,0,0,0,3.24,2.27,3.67,3.67,0,0,0,3.64-.53c0,1.24,0,2.48,0,3.72a2.09,2.09,0,0,1,1.58,3.29c-2.1,5.39-4.22,10.83-7.4,15.66a33.33,33.33,0,0,1,6.2,4.73,27.88,27.88,0,0,1,3.23,4.37c.09.74.16,1.47.2,2.2.74,11.92-3.87,23.75-8,35.11-1.19,3.22-2.49,6.59-2.39,9.94a19.51,19.51,0,0,0-2.24,1.61c.82,2.14.5,4.05.41,6.34a11.23,11.23,0,0,1-.83,4,28.12,28.12,0,0,1-1.44,2.57c-2.59,4.57-3.16,10-3.68,15.22-.31,3.15.91,7-.52,9.82-2.47,4.84-4.66,10-5,15.38a15.42,15.42,0,0,1-.46,3.59c-.31,1-.86,1.85-1.14,2.83a12.11,12.11,0,0,0-.2,4,38.28,38.28,0,0,1-2.1,14.11c-1.25,3.57-2.63,7.39-1.65,11.06a15.59,15.59,0,0,0-4.23,9.29,14.65,14.65,0,0,1-.32,2.65,12.89,12.89,0,0,1-1.2,2.55,22.32,22.32,0,0,0-2.72,12c-3,4.07-4.5,9.09-5.39,14.08s-1.28,10.07-2.42,15c-1.52,6.52-4.27,13.11-4.81,19.79-3.24,2.07-4.64,6.08-5.26,9.87s-.72,7.77-2.31,11.27c-.82,1.82-2,3.45-2.78,5.31a24.38,24.38,0,0,0-1.2,4.57c-.48,2.44-.9,5.16-.31,7.5a11.31,11.31,0,0,1-2.93,2.23c.16-.62.29-1.24.4-1.87-2.58,2.34-7.26,1.52-9.32,4.33a4.22,4.22,0,0,0,1,5.79,8,8,0,0,0,2.07.89c5,1.6,10.14,3.21,15.28,2.36a4.56,4.56,0,0,0,1.73-.55,5.57,5.57,0,0,0,1.61-1.86c.77-1.22,1.54-2.44,2.3-3.66a47.51,47.51,0,0,0,5.61,1.31c.19,1.6.33,3.2.4,4.8,1,.2,2.34.26,2.81-.67a2.43,2.43,0,0,0,.17-1.11c0-.71.1-1.65.16-2.61h.2a19,19,0,0,0,8.85-1.79c-1.07-8.86,2.46-17.52,5.52-25.9,3.23-8.82,6-17.8,8.79-26.78,2-6.32,4.21-12.44,6.17-18.77q3.7-12,7.43-24c1.08-3.52,2.17-7,3.41-10.5a163.57,163.57,0,0,1,9.27-20.63c1-1.89,2-3.76,2.82-5.72,1-2.39,1.71-4.89,2.51-7.36a114,114,0,0,1,6.28-14.78c.07-.13.12-.25.19-.37.81,3.31,1.62,6.67,2.16,10a38,38,0,0,1,.17,12.36c-.48,2.79-1.39,5.55-1.28,8.38.15,3.91,2.24,7.46,3.27,11.23a42.74,42.74,0,0,1,1.12,8.6c.28,4.5,2.72,9.55,1,13.72-5.35,13.21-2.76,28.13-5.81,42-1.57,7.12-6.38,13.81-6,21.09q.4,7.75,1.36,15.46A14.71,14.71,0,0,0,878,836a17.22,17.22,0,0,0,1.37,2.24c-.44.17-.81.62-1.13,1.57-.82,2.5,0,5.6,2.22,7a9.72,9.72,0,0,0,2.89,1,15.22,15.22,0,0,0,4.18.58,9.76,9.76,0,0,0,1.31-.16,47.64,47.64,0,0,0,4.73,1.7c0,.41.08.82.13,1.23a1.53,1.53,0,0,0,.52,1.13,1.56,1.56,0,0,0,.8.14l5.43,0c0-.45,0-.91,0-1.36a4.47,4.47,0,0,0,3.45-1.12,5.34,5.34,0,0,0,1-2.08q2.22-7.53,4.41-15.07a48.18,48.18,0,0,0,2.15-17.2c-1.93-18.43,2.31-36.92.93-55.4a132.71,132.71,0,0,1,1.7-33.24c.45-2.48,1-5,1.2-7.47.44-4.66-.1-9.37.23-14,.11-1.62.33-3.23.53-4.84a232.43,232.43,0,0,0,2.15-30.15,95,95,0,0,0-.62-10,5.71,5.71,0,0,0,2.73-1.6c.89-1.16.66-2.79.65-4.27,0-3.54,1.49-6.88,2.69-10.22a121.44,121.44,0,0,0,3.78-14.06,49.09,49.09,0,0,0,1.68-11.75q0-.6-.06-1.2a3.1,3.1,0,0,0,.92-1,5.81,5.81,0,0,0,.48-1.85c.36-2.55.73-5.11,1.09-7.67q.4-2.75.79-5.49l3.18-22.19c.27-1.93.55-3.85.82-5.77l.83-5.74c.09-.68.19-1.36.26-2C939.86,561.61,937.53,556.17,937.27,551.53Zm-26.53,83.08c-1.18-2.8-2.28-5.67-2-8.69l-.11,0a4.46,4.46,0,0,0-.13-2.82c-.31-.73-.85-1.35-1.18-2.08a7.62,7.62,0,0,1-.54-2.8,76.33,76.33,0,0,1,1.43-18.14c.13-.7.27-1.41.4-2.11a5.22,5.22,0,0,0,1.14-.89,8.11,8.11,0,0,0,1.29-2c1.13-2.27,2.16-4.58,3.11-6.93.31-.76.76-1.64,1.53-1.83-.16,5.85.44,11.82-1.94,17.1a10.82,10.82,0,0,0-1,2.7c-.22,1.49.4,3,.18,4.48-.11.77-.44,1.48-.57,2.24a2.19,2.19,0,0,0,.58,2.12,1.75,1.75,0,0,0,.43.22c-.06.4-.11.81-.15,1.2-.08.82-.12,1.59-.17,2.07a64.5,64.5,0,0,0-.27,7.36c0,2.65.1,5.3.06,8a5.43,5.43,0,0,1-.38,2.27,3.94,3.94,0,0,1-.76,1C911.4,636.18,911.08,635.39,910.74,634.61Z"
      transform="translate(-16.91 -47.46)"
      fill="url(#b7f84a8b-804f-4004-8d61-2f9b427d4893)"
    />
    <ellipse
      cx="828.59"
      cy="502.96"
      rx="5.64"
      ry="15.97"
      transform="translate(-101 129.08) rotate(-11.58)"
      fill="#fbbebe"
    />
    <path
      d="M878.4,840c-.82,2.48,0,5.58,2.22,6.93a9.88,9.88,0,0,0,2.87,1,15.14,15.14,0,0,0,4.17.57c1.73-.08,3.39-.76,5.12-1a.8.8,0,0,1,.59.08.85.85,0,0,1,.22.7,26.43,26.43,0,0,0,.22,2.94,1.51,1.51,0,0,0,.52,1.13,1.56,1.56,0,0,0,.8.14l5.42,0A52.86,52.86,0,0,0,899,838.35a3.16,3.16,0,0,0-.4-1,3.31,3.31,0,0,0-1.73-1,9.67,9.67,0,0,0-4.19-.73c-1.75.23-3.21,1.36-4.7,2.3s-3.52,1.77-5.33,1.29S879.33,837.22,878.4,840Z"
      transform="translate(-16.91 -47.46)"
      fill="#3f3d56"
    />
    <path
      d="M798.82,835.61a15,15,0,0,1-5.47,3.72l-.92.44a.64.64,0,0,0-.31.25.54.54,0,0,0,.1.45,6.47,6.47,0,0,0,7.34,2.67,3.89,3.89,0,0,0,1.61-.84,5.28,5.28,0,0,0,1.24-3.22,6.59,6.59,0,0,0-.15-3.69C800.87,832.26,800.36,833.68,798.82,835.61Z"
      transform="translate(-16.91 -47.46)"
      fill="#fbbebe"
    />
    <path
      d="M819.6,847.93a2.43,2.43,0,0,1-.17,1.11c-.47.92-1.78.87-2.8.67a67.3,67.3,0,0,0-1.23-10.1c-1.94-.09-3.34,1.75-4.38,3.4l-2.68,4.25a5.54,5.54,0,0,1-1.6,1.86,4.74,4.74,0,0,1-1.73.55c-5.12.85-10.29-.76-15.23-2.36a8.07,8.07,0,0,1-2.07-.88,4.23,4.23,0,0,1-1-5.78c2.07-2.8,6.72-2,9.3-4.32a23.28,23.28,0,0,1-1.32,4.77c3.45-.52,5.77-3.68,8.55-5.79a5.26,5.26,0,0,1,2.44-1.16,5.37,5.37,0,0,1,2,.21,23.46,23.46,0,0,1,8.8,4.33c1.05.83,2.69,2,3.15,3.28C820.12,843.5,819.6,846.3,819.6,847.93Z"
      transform="translate(-16.91 -47.46)"
      fill="#3f3d56"
    />
    <circle cx="871.48" cy="449.87" r="20.66" fill="#fbbebe" />
    <path
      d="M929.09,619.31A49,49,0,0,1,927.42,631a120.64,120.64,0,0,1-3.78,14c-1.19,3.33-2.68,6.67-2.67,10.2,0,1.47.24,3.1-.66,4.26a6.22,6.22,0,0,1-2.92,1.67,3.65,3.65,0,0,0-2.46,2.19,15.45,15.45,0,0,1-2.08-4.58q-2.69-8.24-5-16.57a2.15,2.15,0,0,1,.14-2,2.48,2.48,0,0,1,.87-.49,9,9,0,0,0,2.77-1.78,4.05,4.05,0,0,0,.92-1.19,5.39,5.39,0,0,0,.39-2.26c0-2.65,0-5.29-.07-7.94a66.34,66.34,0,0,1,.28-7.33c0-.48.09-1.25.17-2.07.15-1.57.45-3.39,1.3-4,1.27-.85,5.07.29,6.51.49,2.48.34,5,.74,7.42,1.21A19.81,19.81,0,0,1,929.09,619.31Z"
      transform="translate(-16.91 -47.46)"
      fill="#3f3d56"
    />
    <path
      d="M845.67,520.46c-.8,1.6-2.72,2.37-4.2,3.38l-5.07,3.48a3.38,3.38,0,0,1-2.51.86,3.3,3.3,0,0,1-1.87-1.75.35.35,0,0,0,0-.08l-1.05-1.76-5-8.38a4.77,4.77,0,0,1-.93-2.58c0-.43.15-.83.19-1.26a6.05,6.05,0,0,0-1-3.4c-.4-.75-1.2-1.37-1.18-2.21a8,8,0,0,1,.56-3.23,6.54,6.54,0,0,1,2.19-2.34c.47-.34.95-.66,1.45-1a2.86,2.86,0,0,1,.87-.4c.83-.17,1.65.52,2.49.55,3.61,2.42,5,7,7.84,10.3,1.6,1.88,1.76,3.32,3.57,5,.29.26.57.54.84.83a5.81,5.81,0,0,1,.9,1.3C844.09,518.63,846.08,519.64,845.67,520.46Z"
      transform="translate(-16.91 -47.46)"
      fill="#3f3d56"
    />
    <path
      d="M881.13,518c1.49,3.15,2.65,6.61,2.22,10.07a6.29,6.29,0,0,1-.87,2.65c-1.44,2.21-4.46,2.61-7.09,2.74a4.18,4.18,0,0,0-3.08,1,2.8,2.8,0,0,0,.19,3.42,7.72,7.72,0,0,0,3.06,2c4.16,1.83,8.65,3.34,13.17,2.92,2.1-.2,4.14-.81,6.23-1.12a65.41,65.41,0,0,1,6.86-.38c2.72-.1,5.43-.37,8.14-.64l7.18-.71a1.6,1.6,0,0,0,1.07-.39c.53-.62-.15-1.53-.81-2-3.81-2.82-8.66-4.76-10.83-9-1-2-1.31-4.38-2.05-6.54s-1.92-4.11-2.38-6.31a41.81,41.81,0,0,1-.33-5.82,7.81,7.81,0,0,0-2-5.32c-1.43-1.33-3.5-1.67-5.44-1.75-4.78-.21-9.87.93-13.26,4.3-.91.91-1.69,2-2.63,2.82s-2.22,1.06-1.6,2.14,1.84,1.75,2.5,2.7A23,23,0,0,1,881.13,518Z"
      transform="translate(-16.91 -47.46)"
      fill="#fbbebe"
    />
    <path
      d="M921.86,547.09a113.62,113.62,0,0,1-6.12,22.53,84.86,84.86,0,0,0-3.6,10.1c-.77,3.1-.62,6.42-1.33,9.53-.88,3.87-1.76,7.75-2.47,11.65A76.39,76.39,0,0,0,906.92,619a7.57,7.57,0,0,0,.54,2.79c.33.72.86,1.34,1.17,2.08a5,5,0,0,1-.28,4,11.58,11.58,0,0,1-2.06,3.12c-9.32,2.78-19.29,1.87-29,2.46-8.95.54-18,2.38-26.82.85-1-4,.67-8.19,2.1-12.09,4.15-11.33,8.74-23.13,8-35a36.26,36.26,0,0,0-.47-4.13c-1.45-8.41.13-17.12,2.66-25.27,1.57-5.08,1.5-10.49,1.14-15.78a28.82,28.82,0,0,1-.07-5.17,9.09,9.09,0,0,1,1.88-4.83c0-.07.09-.14.14-.21s.44-.06.75,0h0a.64.64,0,0,0,.5,0l.11-.07a.25.25,0,0,1,.29,0c.23.14.36.62.86.71a19.92,19.92,0,0,0,2.23.21,12,12,0,0,1,2.66.38l.12,0a7.81,7.81,0,0,0,3.88-.33,10.31,10.31,0,0,0,2.38-.92c.22-.24,1.6-.46,1.88-.63.91-.55.71-3.13.9-4.19a11.52,11.52,0,0,1,.75-3.1,5.28,5.28,0,0,1,4.28-2.49,22.79,22.79,0,0,1,5.13.46c3.73.53,7.55.44,11.21,1.3,1.84.43,3.85,1.08,5.54.24.46.11.53.51.53,1a6.41,6.41,0,0,1-.28,1.37c-.64,2.76,1.53,5.3,3.53,7.3a11.32,11.32,0,0,0,2.95,2.35c1,.46,2,.65,3,1.15a5.46,5.46,0,0,1,2,1.83,7.64,7.64,0,0,1,1.14,2.91A17.4,17.4,0,0,1,921.86,547.09Z"
      transform="translate(-16.91 -47.46)"
      fill="#3f3d56"
    />
    <path
      d="M921.86,547.09a113.62,113.62,0,0,1-6.12,22.53,84.86,84.86,0,0,0-3.6,10.1c-.77,3.1-.62,6.42-1.33,9.53-.88,3.87-1.76,7.75-2.47,11.65-.21.12-.43.23-.65.33a15.35,15.35,0,0,1-3.92,1.26,24,24,0,0,1-7.32-.24l-14.27-1.91c-5.7-.77-11.77-1.7-16-5.56-2.35-2.12-3.89-4.92-5.58-7.62a36.26,36.26,0,0,0-.47-4.13c-1.45-8.41.13-17.12,2.66-25.27,1.57-5.08,1.5-10.49,1.14-15.78a28.82,28.82,0,0,1-.07-5.17,9.09,9.09,0,0,1,1.88-4.83,7.11,7.11,0,0,1,.89-.2h0a4.44,4.44,0,0,1,.61-.08h.29a4.36,4.36,0,0,1,1,.12,18.09,18.09,0,0,1,2,.77l.12,0a7.66,7.66,0,0,0,2.66.38c1.32,0,2.68-.21,4-.3a7.38,7.38,0,0,1,4.74.85,28.43,28.43,0,0,1,2.64,2.41,11.34,11.34,0,0,0,3.33,1.81,35.39,35.39,0,0,0,26.62-.56,5.21,5.21,0,0,1,2.67-.68,5,5,0,0,1,1.92.82c.6.35,1.19.69,1.8,1a7.64,7.64,0,0,1,1.14,2.91A17.4,17.4,0,0,1,921.86,547.09Z"
      transform="translate(-16.91 -47.46)"
      opacity="0.1"
    />
    <path
      d="M930.57,540.47a53.37,53.37,0,0,1-11.4-5,5.11,5.11,0,0,0-1.92-.82,5.37,5.37,0,0,0-2.68.68,35.37,35.37,0,0,1-26.61.56,11.57,11.57,0,0,1-3.33-1.81,29.9,29.9,0,0,0-2.64-2.41c-3.29-2.13-7.84.37-11.52-1a20.41,20.41,0,0,0-2-.77c-2.91-.73-5.87,2.17-8.73,1.29a48.65,48.65,0,0,0-2.35,8.92,97.23,97.23,0,0,0-.65,10.52c0,2.11-.1,4.22,0,6.33a2.58,2.58,0,0,1,1.74,1.13,2.56,2.56,0,0,1-.16,2.15c-2.09,5.37-4.21,10.8-7.38,15.61a33.92,33.92,0,0,1,6.18,4.72c3.5,3.7,5.22,8.89,9,12.31,4.26,3.85,10.33,4.79,16,5.55l14.27,1.91a24.39,24.39,0,0,0,7.33.25,15.43,15.43,0,0,0,3.91-1.27,7,7,0,0,0,2.18-1.44,8,8,0,0,0,1.29-2c1.13-2.26,2.16-4.57,3.11-6.91.33-.83.83-1.8,1.73-1.87,5.3-4.78,10.3-9.68,15.6-14.46a34.57,34.57,0,0,0,5.69-6c2.63-3.89.24-9.4,0-14.1a17.8,17.8,0,0,0-.45-3.57C935.92,545.56,933.9,541.48,930.57,540.47Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M845.67,520.46c-.8,1.6-2.72,2.37-4.2,3.38l-5.07,3.48a3.38,3.38,0,0,1-2.51.86,3.3,3.3,0,0,1-1.87-1.75c0-.23,0-.48,0-.72a6.71,6.71,0,0,1,.32-2.39,7.45,7.45,0,0,1,2.24-2.88,18.34,18.34,0,0,1,6.57-4,2.25,2.25,0,0,1,1.2-.12,1.58,1.58,0,0,1,.44.19,5.81,5.81,0,0,1,.9,1.3C844.09,518.63,846.08,519.64,845.67,520.46Z"
      transform="translate(-16.91 -47.46)"
      opacity="0.1"
    />
    <path
      d="M857.61,531c-1.7-.08-3.09-1.31-4.33-2.48L849.49,525a3.54,3.54,0,0,1-.66-.74,5.19,5.19,0,0,1-.46-1.23,14.11,14.11,0,0,0-3.68-5.28,2.4,2.4,0,0,0-1.09-.78,2.19,2.19,0,0,0-1.21.12,18.29,18.29,0,0,0-6.57,4,7.47,7.47,0,0,0-2.24,2.88,6.65,6.65,0,0,0-.32,2.39A18.36,18.36,0,0,0,835,534c.17.37.36.74.56,1.1a34.63,34.63,0,0,0,4.7,6.11l2.38,2.66c2.34,2.62,4.68,5.24,7.22,7.65a9.54,9.54,0,0,0,3.24,2.26,3.62,3.62,0,0,0,3.72-.6,5.38,5.38,0,0,0,1.06-1.9c1.54-4,3-8.16,3.09-12.47a47.06,47.06,0,0,0-.22-5.17C860.6,531.82,859.31,531.11,857.61,531Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M918.21,671a231.07,231.07,0,0,1-2.14,30.07c-.2,1.61-.42,3.22-.53,4.83-.33,4.67.21,9.36-.23,14-.23,2.51-.75,5-1.19,7.45a132.47,132.47,0,0,0-1.7,33.15c1.38,18.43-2.85,36.87-.93,55.25a44.66,44.66,0,0,1-.59,10.69,45.3,45.3,0,0,1-1.55,6.46q-2.19,7.51-4.4,15a5.2,5.2,0,0,1-1,2.08,4.74,4.74,0,0,1-3.75,1.11c-5.77-.18-11.2-2.67-16.44-5.1a5.73,5.73,0,0,1-1.65-1c-1.09-1.13-1-2.91-1.48-4.4s-1.78-2.89-2.52-4.42a14.43,14.43,0,0,1-1.09-4.55q-1-7.68-1.36-15.42c-.38-7.26,4.42-13.94,6-21,3-13.88.46-28.76,5.79-41.93,1.68-4.16-.76-9.2-1-13.68a43.37,43.37,0,0,0-1.12-8.58c-1-3.76-3.11-7.3-3.26-11.2-.11-2.82.8-5.57,1.27-8.35a37.53,37.53,0,0,0-.17-12.33c-.53-3.36-1.34-6.72-2.15-10l-.18.37a113,113,0,0,0-6.27,14.75c-.8,2.45-1.5,4.95-2.5,7.33-.82,2-1.83,3.83-2.82,5.71A164,164,0,0,0,860,737.84c-1.24,3.46-2.33,7-3.41,10.47l-7.41,24c-2,6.31-4.19,12.41-6.15,18.71-2.77,9-5.54,17.92-8.76,26.72-3,8.35-6.57,17-5.5,25.82a19,19,0,0,1-8.83,1.79,51.7,51.7,0,0,1-15-3.64c-1.91-.71-3.89-1.51-5.18-3.08-2.22-2.71-1.67-6.68-1-10.13a24.49,24.49,0,0,1,1.2-4.56c.76-1.84,2-3.47,2.78-5.29,1.57-3.49,1.67-7.44,2.29-11.23s2-7.79,5.24-9.85c.55-6.66,3.29-13.23,4.8-19.74,1.14-4.93,1.52-10,2.42-15s2.35-10,5.37-14.05a22.27,22.27,0,0,1,2.72-12,13.12,13.12,0,0,0,1.19-2.55,14.65,14.65,0,0,0,.32-2.64,15.61,15.61,0,0,1,4.22-9.27c-1-3.65.39-7.46,1.64-11a38.22,38.22,0,0,0,2.1-14.07,12.33,12.33,0,0,1,.19-4c.28-1,.83-1.85,1.15-2.81a16,16,0,0,0,.45-3.59c.39-5.41,2.58-10.51,5-15.34,1.44-2.82.22-6.65.52-9.79.52-5.22,1.09-10.62,3.68-15.17.48-.86,1-1.68,1.43-2.57a11.13,11.13,0,0,0,.83-4c.09-2.29.41-4.19-.41-6.32,5.35-4.45,12.65-5.7,19.61-6s14,.33,20.81-1.15c2-.45,4-1.07,6.11-1.37,4.79-.7,9.65.39,14.38,1.47-.33,3,.77,5.88,2,8.67A93.07,93.07,0,0,1,918.21,671Z"
      transform="translate(-16.91 -47.46)"
      fill="#33313f"
    />
    <path
      d="M894.66,673.29l-11.49,25.84c-.53-3.36-1.34-6.72-2.15-10l-.18.37,0-.54,6.26-13.77Z"
      transform="translate(-16.91 -47.46)"
      opacity="0.1"
    />
    <path
      d="M929.09,619.31a4.32,4.32,0,0,1-2.28.85,11.09,11.09,0,0,1-3.74-.51l-9-2.25a4.42,4.42,0,0,1-.82-.29c.15-1.57.45-3.39,1.3-4,1.27-.85,5.07.29,6.51.49,2.48.34,5,.74,7.42,1.21A19.81,19.81,0,0,1,929.09,619.31Z"
      transform="translate(-16.91 -47.46)"
      opacity="0.1"
    />
    <path
      d="M936.7,559.81c.19.83.46,1.65.62,2.49a19,19,0,0,1-.21,6.19l-.82,5.72-.82,5.75-3.17,22.13-.78,5.48-1.1,7.65a5.5,5.5,0,0,1-.48,1.84,3.83,3.83,0,0,1-3.13,1.85,11.34,11.34,0,0,1-3.74-.51l-9-2.26a2.82,2.82,0,0,1-1.1-.45,2.17,2.17,0,0,1-.58-2.11c.13-.76.46-1.47.57-2.23.22-1.48-.4-3-.18-4.47a11.12,11.12,0,0,1,1-2.69c3-6.63,1.26-14.37,2.28-21.57A32.7,32.7,0,0,1,923,567.18a44.32,44.32,0,0,1,7.66-7.52c1.12-.87,2.9-2.66,4.31-3C936.78,556.28,936.4,558.55,936.7,559.81Z"
      transform="translate(-16.91 -47.46)"
      fill="#158cba"
    />
    <path
      d="M868.59,473.67c-.66,2.1.37,4.41-.1,6.55-.51,2.36-2.73,4-3.36,6.37-1,3.61,2.06,6.9,4.3,9.9,8.3,11.14,7.21,26.56,4.37,40.15a207.31,207.31,0,0,1-9.45,32c-1.25,3.23-2.63,6.51-5.09,8.93,4.6-1.32,9.49-2.65,14.1-1.37,5.84,1.62,10.88,7.29,16.8,6,3.56-.79,6.06-3.95,9.26-5.7,6-3.23,13.23-1.2,19.92-.16a7.82,7.82,0,0,0,4.35-.22,7.23,7.23,0,0,0,2.64-2.43,24.66,24.66,0,0,0,5.14-13.3,17.06,17.06,0,0,0-4.91-13.13c-1.42-1.34-3.12-2.42-4.21-4a12.42,12.42,0,0,1-1.65-6.06c-.79-11,1.89-22.23-.87-32.87-1-3.79-2.63-7.42-3.07-11.3-.55-4.83.76-10-1.16-14.42-1.51-3.51-4.84-6-8.43-7.28s-7.43-1.64-11.24-2C890.45,468.87,870.88,466.52,868.59,473.67Z"
      transform="translate(-16.91 -47.46)"
      fill="#33313f"
    />
    <g opacity="0.1">
      <path
        d="M873.8,536.64a206.9,206.9,0,0,1-9.4,31.87c.69-1.37,1.27-2.81,1.82-4.24a206.21,206.21,0,0,0,9.45-32c2.85-13.6,3.94-29-4.36-40.15-2-2.66-4.57-5.54-4.48-8.66a10.66,10.66,0,0,0-1.7,3.14c-1,3.61,2.06,6.9,4.3,9.9C877.73,507.63,876.64,523.05,873.8,536.64Z"
        transform="translate(-16.91 -47.46)"
      />
      <path
        d="M868.61,479.21a9.73,9.73,0,0,0,1.76-3.37,17.13,17.13,0,0,0-.12-4.46,4.81,4.81,0,0,0-1.66,2.29C868,475.44,868.68,477.36,868.61,479.21Z"
        transform="translate(-16.91 -47.46)"
      />
      <path
        d="M928.21,569.29a7.2,7.2,0,0,1-2.64,2.42,7.64,7.64,0,0,1-4.35.22c-6.69-1-14-3.06-19.92.17-3.21,1.74-5.7,4.9-9.27,5.7-5.91,1.32-10.95-4.35-16.79-6-4.14-1.15-8.5-.2-12.67,1a17.47,17.47,0,0,1-3.31,4.78c4.6-1.32,9.49-2.65,14.1-1.37,5.84,1.62,10.88,7.29,16.8,6,3.56-.79,6.06-3.95,9.26-5.7,6-3.23,13.23-1.2,19.92-.16a7.82,7.82,0,0,0,4.35-.22,7.23,7.23,0,0,0,2.64-2.43,26.88,26.88,0,0,0,4.14-7.92A29.08,29.08,0,0,1,928.21,569.29Z"
        transform="translate(-16.91 -47.46)"
      />
    </g>
  </svg>
  <h2 *ngIf="loading" class="my-auto">{{ 'common.loading' | translate }}...</h2>
  <h4 *ngIf="error" class="my-auto text-danger">
    {{ 'adminLogin.error' | translate }}
  </h4>
  <app-footer></app-footer>
</div>
